<div class="p-4">
    <p>{{translateArr.bp9}} <b>{{local_data}}</b> ?</p>
    <h5>*{{translateArr.bp10}}</h5>
    <div mat-dialog-actions align="end" class="pt-4">
        <button class="btn button cancel-button mr-3" (click)="closeDialog()">{{translateArr.bp11}}</button>
        <button class="btn button" (click)="doAction(local_data)" color="warn">{{translateArr.bp12}}</button>
    </div>
</div>